import { render, staticRenderFns } from "./ContactTypeList.vue?vue&type=template&id=2868e646&"
import script from "./ContactTypeList.vue?vue&type=script&lang=js&"
export * from "./ContactTypeList.vue?vue&type=script&lang=js&"
import style0 from "./ContactTypeList.vue?vue&type=style&index=0&id=2868e646&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports